import { applyStoredColorScheme } from '@myosh/design-system';
import { TooltipProvider } from '@myosh/odin-components';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import '@myosh/odin-translations/i18n';
import './index.css';
import store from './redux/store';

applyStoredColorScheme();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <TooltipProvider>
        <App />
      </TooltipProvider>
    </Provider>
  </React.StrictMode>
);
